module.exports = __webpack_public_path__ + "static/images/step2.6b023c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step2.png
// module id = pzm4
// module chunks = 1